import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as OrganizationActionCreators from '../../actions/organization'

import OrganizationAdmin from './OrganizationAdmin'

class OrganizationAdminContainer extends React.Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    organizationActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      organizations: state.organizations,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      organizationActions: bindActionCreators(OrganizationActionCreators, dispatch),
    }
  }

  render() {
    const { organizations, organizationActions } = this.props

    return (
      <OrganizationAdmin
        organizations={organizations}
        onCreateOrg={organizationActions.createOrganization}
        onUpdateOrg={organizationActions.updateOrganization}
      />
    )
  }
}

export default connect(
  OrganizationAdminContainer.mapStateToProps,
  OrganizationAdminContainer.mapDispatchToProps,
)(OrganizationAdminContainer)
